module.exports = __webpack_public_path__ + "assets/img/idol.1b4caaa4.jpg";